// src/services/apiCalls.js
import api from '../services/api.js';

const getData = async (endpoint) => {
  try {
    const token = localStorage.getItem('token');

    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    };

    const response = await api.get(endpoint, config);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

const postData = async (endpoint, data, extraConfig = {}) => {
  try {
    const token = localStorage.getItem('token');

    const config = {
      ...extraConfig,
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        ...(extraConfig.headers || {}),
      },
    };

    // Dejar que el browser setee boundary en multipart
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    const response = await api.post(endpoint, data, config);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

const putData = async (endpoint, data) => {
  try {
    const token = localStorage.getItem('token');

    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    };

    const response = await api.put(endpoint, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const patchData = async (endpoint, data) => {
  try {
    const token = localStorage.getItem('token');

    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
    };

    const response = await api.patch(endpoint, data, config);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

const deleteData = async (endpoint) => {
  try {
    const token = localStorage.getItem('token');

    const config = {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    };

    const response = await api.delete(endpoint, config);
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || 'Ocurrió un error inesperado';

    throw new Error(errorMessage);
  }
};

// Objeto httpClient con métodos GET, POST, PUT, PATCH, DELETE
const httpClient = {
  get: getData,
  post: postData,
  put: putData,
  patch: patchData,
  delete: deleteData,
};

export { getData, postData, putData, patchData, deleteData };
export default httpClient;
